import { render, staticRenderFns } from "./customerdialog.vue?vue&type=template&id=57d8e708&scoped=true"
import script from "./customerdialog.vue?vue&type=script&lang=js"
export * from "./customerdialog.vue?vue&type=script&lang=js"
import style0 from "./customerdialog.vue?vue&type=style&index=0&id=57d8e708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d8e708",
  null
  
)

export default component.exports